import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 0;
  background: ${(props) => props.theme.colors.card};
  border: 1px solid ${(props) => props.theme.colors.disabled};
  border-radius: 10px;
  box-shadow: none;
  /* Breadcumb tem padding proprio (15px 15px 15px 35px) — Container so
     prove o fundo do card. */
  overflow: hidden;
`;

export const Label = styled.label`
  font-size: ${(props) => (props.size ? props.size : '15px')};
  color: ${(props) => props.color};

  ${(props) => props.pointer && 'cursor: pointer'};
  ${(props) => props.bold && 'font-weight: bold'};
  ${(props) => props.pointer && ':hover {text-decoration:underline;}'}
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: ${(props) => props.theme.colors.red};
  width: 30px;
  height: 20px;
  padding: 5px;
`;
